import { Input } from "@/components/ui/input";
import { useState, useEffect } from "react";
import { BasicTooltip } from "@/components/ui/Tooltip";
import { Info } from "lucide-react";
import { URLInputProps } from "./types";

export const URLInput = ({
  value = "",
  onChange,
  onBlur,
  placeholder,
  label,
  tooltip,
  readOnly = false,
  error,
  showError = false,
  className,
}: URLInputProps) => {
  const [displayValue, setDisplayValue] = useState("");

  useEffect(() => {
    if (value) {
      setDisplayValue(
        value.startsWith("https://") ? value.substring(8) : value,
      );
    } else {
      setDisplayValue("");
    }
  }, [value]);

  const onInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const inputValue = e.target.value;
    setDisplayValue(inputValue);

    const fullValue = inputValue ? `https://${inputValue}` : "";
    onChange?.(fullValue);
  };

  const onInputBlur = (e: React.FocusEvent<HTMLInputElement>) => {
    const inputValue = e.target.value;
    let finalValue: string;

    if (inputValue.startsWith("https://")) {
      setDisplayValue(inputValue.substring(8));
      finalValue = inputValue;
    } else {
      finalValue = inputValue ? `https://${inputValue}` : "";
    }

    onBlur?.(finalValue);
  };

  return (
    <div className={className}>
      {label && (
        <div className="flex items-center gap-2">
          <label className="text-sm font-medium text-gray-700">{label}</label>
          {tooltip && (
            <BasicTooltip content={tooltip}>
              <Info className="h-4 w-4 cursor-pointer text-gray-500 hover:text-gray-700" />
            </BasicTooltip>
          )}
        </div>
      )}
      <div className="flex items-center">
        <div className="h-9 w-fit items-center justify-center rounded-l-md rounded-r-none border border-r-0 border-gray-300 bg-gray-50 px-3 py-2 text-sm text-gray-500">
          https://
        </div>
        <Input
          onChange={onInputChange}
          readOnly={readOnly}
          autoCorrect="off"
          autoCapitalize="off"
          spellCheck="false"
          value={displayValue}
          onBlur={onInputBlur}
          className="rounded-l-none"
          placeholder={placeholder}
        />
      </div>
      {error && showError && <p className="text-sm text-red-500">{error}</p>}
    </div>
  );
};
